import React from 'react';
import Filter from 'components/Category/Filter';
import FilterPrice from 'components/Category/FilterPrice';
import { BUNDLE, COURSE, COURSE_AND_PRODUCT, PRODUCT } from 'variables/item_variation';
import { isDefaultUrl } from 'utils/is_default_url';

const AllFilterComponent = (props) => {
  const {
    itemVariation,
    fullWidth,
    handleFilter,
    courseType,
    filterCourseType,
    learningProgram,
    filterLearningProgram,
    delivery,
    filterDelivery,
    duration,
    filterDuration,
    price,
    filterPrice,
    priceFilter,
    type,
    filterType,
    readingTime,
    filterReadingTime,
    language,
    filterLanguage,
    provider,
    filterProvider,
    languageProduct,
    filterLanguageProduct,
    providerProduct,
    filterProviderProduct,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    defaultMaxPrice,
    slug,
    cluster,
    filterCluster
  } = props;

  let newCluster = cluster?.map((item) => ({ ...item, id: item.name })) || [];

  const getProvider = (arr) => {
    return arr?.reduce((acc, curr) => {
      const existing = acc.find(item => item.id === curr.id);
      if (existing) {
        existing.count += curr.count;
      } else {
        acc.push({ ...curr });
      }
      return acc;
    } , []);
  }

  return (
    <div className="filter-container">
       {itemVariation !== COURSE && itemVariation !== PRODUCT && !window.location.search.includes('?courses=all') && !window.location.search.includes('?products=all') && !window.location.search.includes('?bundles=all') && itemVariation.includes(COURSE_AND_PRODUCT) ? (
        <Filter
          title="Cluster"
          fullWidth={fullWidth}
          data={newCluster}
          checkedData={filterCluster}
          handleFilter={(id) => handleFilter(id, 'cluster')}
        />
      ) : null}

      {itemVariation.includes(PRODUCT) && !itemVariation.includes(COURSE_AND_PRODUCT) ? (
        <Filter
          title="Product Type"
          fullWidth={fullWidth}
          data={type}
          checkedData={filterType}
          handleFilter={(id) => handleFilter(id, 'type')}
        />
      ) : null}
        <FilterPrice  
          title="Price Range (USD)"
          fullWidth={fullWidth}
          price={price}
          priceFilter={priceFilter}
          minPrice={minPrice}
          setMinPrice={setMinPrice}
          maxPrice={maxPrice}
          setMaxPrice={setMaxPrice}
          defaultMaxPrice={defaultMaxPrice}
          handleFilter={(id) => handleFilter(id, 'price')} />
      {itemVariation.includes(COURSE) ? (
        <Filter
          title="Course Level"
          fullWidth={fullWidth}
          data={courseType}
          checkedData={filterCourseType}
          handleFilter={(id) => handleFilter(id, 'courseType')}
        />
      ) : null}
      {itemVariation === COURSE ? (
        <Filter
          title="Course Type"
          fullWidth={fullWidth}
          data={learningProgram}
          checkedData={filterLearningProgram}
          handleFilter={(id) => handleFilter(id, 'learningProgram')}
        />
      ) : null}
      {itemVariation.includes(COURSE) ? (
        <Filter
          title="Delivery Method"
          fullWidth={fullWidth}
          data={delivery}
          checkedData={filterDelivery}
          handleFilter={(id) => handleFilter(id, 'delivery')}
        />
      ) : null}
      {itemVariation.includes(COURSE) && !itemVariation.includes(COURSE_AND_PRODUCT) ? (
        <Filter
          title="Duration"
          fullWidth={fullWidth}
          data={duration}
          checkedData={filterDuration}
          handleFilter={(id) => handleFilter(id, 'duration')}
        />
      ) : null}
      {itemVariation.includes(COURSE) ? (
        <Filter
          title="Language"
          fullWidth={fullWidth}
          data={language}
          checkedData={filterLanguage}
          handleFilter={(id) => handleFilter(id, 'language')}
        />
      ) : null}
      {itemVariation.includes(COURSE) && isDefaultUrl() ? (
        <Filter
          slug={slug}
          title="Provider"
          fullWidth={fullWidth}
          data={getProvider(provider)}
          checkedData={filterProvider}
          handleFilter={
            slug && slug.provider && slug.provider !== 'all' ? () => {} : (id) => handleFilter(id, 'provider')
          }
        />
      ) : null}

      {/* {itemVariation.includes(PRODUCT) ? (
        <Filter
          title="Price"
          fullWidth={fullWidth}
          data={price}
          checkedData={filterPrice}
          handleFilter={(id) => handleFilter(id, 'price')}
        />
      ) : null} */}
      {itemVariation.includes(PRODUCT) && !itemVariation.includes(COURSE_AND_PRODUCT) ? (
        <Filter
          title="Reading Time"
          fullWidth={fullWidth}
          data={readingTime}
          checkedData={filterReadingTime}
          handleFilter={(id) => handleFilter(id, 'readingTime')}
        />
      ) : null}
      {itemVariation === PRODUCT ? (
        <Filter
          title="Language"
          fullWidth={fullWidth}
          data={languageProduct}
          checkedData={filterLanguageProduct}
          handleFilter={(id) => handleFilter(id, 'language')}
        />
      ) : null}
      {itemVariation === PRODUCT && isDefaultUrl() ? (
        <Filter
          title="Provider"
          fullWidth={fullWidth}
          data={getProvider(providerProduct)}
          checkedData={filterProviderProduct}
          handleFilter={(id) => handleFilter(id, 'provider')}
        />
      ) : null}

      {itemVariation.includes(BUNDLE) ? (
        <Filter
          title="Bundle Type"
          fullWidth={fullWidth}
          data={type}
          checkedData={filterType}
          handleFilter={(id) => handleFilter(id, 'type')}
        />
      ) : null}
      {/* {itemVariation.includes(BUNDLE) ? (
        <Filter
          title="Price"
          fullWidth={fullWidth}
          data={price}
          checkedData={filterPrice}
          handleFilter={(id) => handleFilter(id, 'price')}
        />
      ) : null} */}
      {itemVariation === BUNDLE ? (
        <Filter
          title="Language"
          fullWidth={fullWidth}
          data={languageProduct}
          checkedData={filterLanguageProduct}
          handleFilter={(id) => handleFilter(id, 'language')}
        />
      ) : null}
      {/* {itemVariation.includes(BUNDLE) ? (
        <Filter
          title="Reading Time"
          fullWidth={fullWidth}
          data={readingTime}
          checkedData={filterReadingTime}
          handleFilter={(id) => handleFilter(id, 'readingTime')}
        />
      ) : null} */}
      {/* {itemVariation.includes(BUNDLE) ? (
        <Filter
          title="Duration"
          fullWidth={fullWidth}
          data={duration}
          checkedData={filterDuration}
          handleFilter={(id) => handleFilter(id, 'duration')}
        />
      ) : null} */}
      {itemVariation === BUNDLE && isDefaultUrl() ? (
        <Filter
          title="Provider"
          fullWidth={fullWidth}
          data={getProvider(providerProduct)}
          checkedData={filterProviderProduct}
          handleFilter={(id) => handleFilter(id, 'provider')}
        />
      ) : null}
    </div>
  );
};

export default AllFilterComponent;
